import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { resendEmail, verifyUser } from '../actions/userActions'
import FormContainer from '../components/FormContainer'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { userSendVerifyEmailReset } from '../reducers/userReducers'
import { COLORS } from '../constants/colors';

function VerifyScreen() {
    const {uidb64, token} = useParams()

    const {
        userReducers : { 
            userVerifyLoading, 
            userVerifySuccess, 
            userVerifyError, 
            userSendVerifyEmailLoading, 
            userSendVerifyEmailSuccess, 
            userSendVerifyEmailError,
            userInfo 
        }
    } = useSelector((state) => state)

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    const redirect = location.search ? location.search.split('=')[1] : '/profile'

    useEffect(() => {
        dispatch(verifyUser(uidb64,token))
    }, [dispatch, uidb64, token])

    useEffect(() => {
        if (userVerifySuccess) {
            toast.success('Account verified successfully! Redirecting to profile...', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "dark",
            });

            // Redirect to profile page after 3 seconds
            const timer = setTimeout(() => {
                navigate('/profile');
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [navigate, userVerifySuccess])

    useEffect(() => {
        if (userInfo) {
            navigate('/profile');
        }
    }, [userInfo, navigate]);

    const [email, setEmail] = useState('')

    const submitHandler = (e) => {
        e.preventDefault()
        dispatch(resendEmail(email))
    }

    useEffect(() => {
        if (userSendVerifyEmailLoading) {
            toast.info("Sending verification email...", {
                position: "top-right",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                theme: "dark",
            })
        }
        
        if (!userSendVerifyEmailLoading) {
            if (userSendVerifyEmailSuccess){
                toast.dismiss()
                dispatch(userSendVerifyEmailReset())
                toast.success(`Please check your email (${email}) for the verification link. The link is valid for 1 hour. Don't forget to check your spam folder if you don't see it in your inbox.`, {
                    position: "top-right",
                    autoClose: 8000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "dark",
                })
            }
  
            if (userSendVerifyEmailError) {
                toast.dismiss()
                toast.error(userSendVerifyEmailError, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "dark",
                })
            }
        }
    }, [userSendVerifyEmailLoading, userSendVerifyEmailSuccess, dispatch, userSendVerifyEmailError, email])

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
            {userVerifyLoading ? <Loader />
            : userVerifySuccess ?
            <Message variant={'success'}>
                <Col className='text-center'>
                    <h4>Account Verified Successfully!</h4>
                    <p>You will be redirected to your profile page in a moment to complete your account setup.</p>
                    <p>If you are not redirected, <Link className='fw-bold text-decoration-none link-white' to={'/profile'}>click here</Link></p>
                </Col>
            </Message>
            :
            <>
                <Message variant={'danger'}>{userVerifyError}</Message>
                <FormContainer>
                    <Col className='h4 text-center mt-4 mb-3 border-bottom pb-4'>Need a new verification email?</Col>
                    <Form onSubmit={submitHandler}>
                        <Form.Group controlId='email'>
                            <Form.Label className='my-2 fw-semibold'>Email Address</Form.Label>
                            <Form.Control
                                type='email'
                                placeholder='Enter Email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Form.Group>

                        <Button 
                            type='submit' 
                            style={{ backgroundColor: COLORS.SAGE_GREEN, borderColor: COLORS.WARM_CONCRETE }}
                            className='my-3 w-50'
                        >
                            Resend Verification Email
                        </Button>
                    </Form>

                    <Row className='py-3'>
                        <Col>
                            New user? <Link to={redirect ? `/register?redirect=${redirect}` : '/register'} className='link fw-semibold'>
                                Register here
                            </Link>
                        </Col>
                    </Row>
                </FormContainer>
            </>
            }
        </>
    )
}

export default VerifyScreen
